export default "__VITE_ASSET__9pMaKTkL__"